/* =========================================================
   I.META 사이트 콘텐츠 — 문구·데이터 단일 출처
   ========================================================= */

export const COMPANY = {
  name: "I.META",
  nameKo: "아이닷메타",
  tagline: "Intelligence Makes Everything Think & Act.",
  motto: "Sense. Think. Act.",
  positioning: "하드웨어 제품화 파트너 (Product Venture Partner)",
  ceo: "선성태",
  bizNo: "394-61-00264",
  mailOrderNo: "2019-전남보성-00057", // 통신판매업 신고번호
  email: "idotmeta@gmail.com",
  phone: "010-9601-4161",
  address: "전남 보성군 벌교읍 벌교연동길 40",
  labLabel: "광주 연구소",
  labAddress: "전남광주통합특별시 화순군 도곡면 지강로 484",
  bizCondition: "정보통신업 / 제조업 / 도매 및 소매업",
  bizItem: "응용 소프트웨어 개발 및 공급업 / 전자기기 제조업 / 전자상거래 소매업",
  origin: "https://idotmeta.co.kr",
  /* 판매제품 입금 계좌 — 백엔드 app/orders.py 의 BANK 와 맞춘다 */
  bank: { name: "카카오뱅크", account: "3333-24-3064824", holder: "아이닷메타(I.META)" },
};

/* 교환 · 환불 안내 — /refund 페이지 (사이트 하단 · 상품 상세 · 주문서에서 링크).
   전자상거래법(청약철회 7일 등)을 기준으로 쓴 것이다. 바꾸면 페이지에 바로 반영된다 */
export const REFUND_POLICY = {
  effective: "2026년 11월 6일",
  sections: [
    {
      title: "주문 취소",
      list: [
        "계좌이체 주문은 입금 전이라면 MY 페이지 › 주문내역에서 직접 [주문 취소]할 수 있습니다.",
        "입금 · 카드결제가 끝난 뒤 발송 전 취소는 주문번호와 함께 문의해 주세요. 확인 후 전액 환불(카드결제는 승인 취소)합니다.",
        "발송이 시작된 뒤에는 아래 교환 · 반품 절차를 따릅니다.",
      ],
    },
    {
      title: "교환 · 반품 신청 기간",
      list: [
        "상품을 받은 날부터 7일 이내에 신청할 수 있습니다.",
        "받은 상품이 표시 · 광고 내용과 다르거나 주문 내용과 다르게 이행된 경우에는 받은 날부터 3개월 이내, 그 사실을 안 날(또는 알 수 있었던 날)부터 30일 이내에 신청할 수 있습니다.",
      ],
    },
    {
      title: "신청 방법",
      list: [
        `MY 페이지에서 주문번호를 확인한 뒤 이메일(${COMPANY.email}) · 전화(${COMPANY.phone}) · 개발 문의로 알려 주세요.`,
        "교환 · 반품 사유와 상품 상태 사진을 함께 보내 주시면 더 빨리 처리됩니다.",
        "반품 상품은 안내드린 주소로 보내 주세요. 미리 연락 없이 보낸 상품은 확인이 늦어질 수 있습니다.",
      ],
    },
    {
      title: "배송비 부담",
      list: [
        "단순 변심에 의한 교환 · 반품: 왕복 배송비(편도 3,000원 기준 6,000원)를 고객님이 부담합니다. 무료배송으로 받은 주문은 처음 배송비까지 포함됩니다.",
        "상품 불량 · 파손 · 오배송: 배송비는 판매자가 부담합니다.",
      ],
    },
    {
      title: "교환 · 반품이 제한되는 경우",
      list: [
        "고객님의 책임 있는 사유로 상품이 멸실 · 훼손된 경우 (단, 내용 확인을 위해 포장을 뜯은 경우는 제외)",
        "납땜 · 배선 · 조립 · 프로그램 기록 등 사용하거나 가공하여 상품의 가치가 현저히 줄어든 경우 (전자부품 · 모듈 특성상 해당됩니다)",
        "시간이 지나 다시 판매하기 곤란할 정도로 상품의 가치가 현저히 줄어든 경우",
        "복제가 가능한 상품(소프트웨어 등)의 포장을 훼손했거나 이미 내려받은 경우",
        "주문에 따라 개별 제작되는 상품 · 용역(펌웨어 개발 등)으로, 제작 · 작업을 시작한 뒤인 경우 — 작업을 시작하기 전에는 전액 환불됩니다",
        "위의 경우라도 상품 자체에 하자가 있으면 교환 또는 환불해 드립니다.",
      ],
    },
    {
      title: "환불",
      list: [
        "반품 상품이 도착해 상태를 확인한 날부터 3영업일 이내에 환불합니다.",
        "카드결제: 카드 승인을 취소합니다. 카드사에 따라 실제 반영까지 3~7영업일이 걸릴 수 있습니다.",
        "계좌이체: 고객님이 알려 주신 계좌로 송금합니다.",
        "환불 금액에서 고객님이 부담할 배송비가 있으면 그만큼 빼고 환불합니다.",
      ],
    },
    {
      title: "문의",
      list: [
        `${COMPANY.name}(${COMPANY.nameKo}) · 대표 ${COMPANY.ceo} · 사업자등록번호 ${COMPANY.bizNo} · 통신판매업 신고 ${COMPANY.mailOrderNo}`,
        `이메일 ${COMPANY.email} · 전화 ${COMPANY.phone}`,
        `반품 주소 ${COMPANY.address}`,
      ],
    },
  ],
};

/* 서비스 메뉴 — 상단 '서비스' 드롭다운 · /services 소개 페이지 · 푸터가 함께 쓴다 */
export const SERVICE_ITEMS = [
  { to: "/partnership", label: "제품개발 서비스", desc: "아이디어를 시제품부터 양산까지" },
  { to: "/services/website", label: "웹사이트 개발 서비스", desc: "자영업자 홈페이지 빠른 구축" },
  { to: "/services/consulting", label: "개발지원 서비스", desc: "개발 컨설팅" },
  { to: "/funding", label: "정부지원사업 연계", desc: "창업·시제품 지원사업 기술 파트" },
];

/* --------------------------------------------------------
   판매제품 · 포럼 — 메인 메뉴에 바로 놓는다.
   1차 배포에서 준비가 덜 된 항목은 false 로 내려 메뉴에서 숨긴다.
   (라우트는 그대로 살아 있어 기존 링크 · 주문 · 로그인 흐름은 깨지지 않는다)
   community 는 아직 페이지가 없어 false.
   -------------------------------------------------------- */
export const FEATURES = {
  shop: true,
  learn: true,
  community: false,
};

/* 문서 사이트맵의 /shop · /learn 은 /products · /forum 으로 연결된다(App.js).
   예전 자료실 주소(/resources)도 /forum 으로 넘어간다. */
export const RESOURCE_ITEMS = [
  { to: "/products", label: "판매제품", desc: "개발보드·모듈 판매", feature: "shop" },
  { to: "/forum", label: "포럼", desc: "개발 노트·자료·Q&A", feature: "learn" },
  { to: "/community", label: "자유게시판", desc: "자유게시판", feature: "community" },
].filter((it) => FEATURES[it.feature]);

/* 메인 메뉴 — '서비스'(드롭다운) 다음에 이어지는 단일 메뉴 */
export const NAV_ITEMS = [
  { to: "/process", label: "진행 방식" },
  { to: "/works", label: "개발 사례" },
  ...RESOURCE_ITEMS,
];
/* 라오나봇은 메뉴가 아니라 로고 옆 배지로 들어간다 (Layout 의 Nav) */

/* 포럼 분류 — 백엔드 app/forum.py 의 CATEGORIES 와 글자 그대로 맞춘다 */
export const FORUM_CATEGORIES = [
  { id: "stm32", label: "STM32" },
  { id: "esp32", label: "ESP32" },
  { id: "rpi", label: "라즈베리파이" },
  { id: "software", label: "소프트웨어" },
  { id: "print3d", label: "3D프린팅" },
];

/* 판매제품 탭 — sstoa 제품 관리의 '분류' 값과 글자 그대로 맞춘다 */
export const SHOP_CATEGORIES = ["제품", "퍼니키트", "PCB모듈", "기구물", "소프트웨어", "설계자료"];
/* 판매제품 화면에서 탭만 감춘 분류 — 관리 화면에서는 계속 고를 수 있고, 상품은 '전체'에 나온다 */
export const SHOP_HIDDEN_TABS = ["제품", "기구물", "설계자료"];

/* --------------------------------------------------------
   개발 사례 — 내용은 SSTOA '개발 사례 관리'에서 등록하고 /api/works 로 불러온다(useWorks).
   여기에는 분류 · 선택지만 둔다. 값은 백엔드 site_works 와 글자 그대로 맞춘다.
   -------------------------------------------------------- */
/* 개발 사례 분류 — /works 섹션 순서 */
export const WORK_CATEGORIES = [
  { id: "hardware", label: "하드웨어 개발", icon: "Chip" },
  { id: "software", label: "소프트웨어 개발", icon: "Code" },
  { id: "web", label: "웹서비스 개발", icon: "Globe" },
];

/* 사진이 없는 카드에 보일 분류 아이콘 */
export const WORK_CATEGORY_ICON = Object.fromEntries(WORK_CATEGORIES.map((c) => [c.id, c.icon]));

/* 담당 범위 태그 선택지 (SSTOA 입력 화면) */
export const WORK_SCOPE_TAGS = ["회로", "PCB", "펌웨어", "기구", "소프트웨어", "서버", "웹"];

/* 진행 방식 태그 — 비우면 표시하지 않는다 */
export const WORK_MODES = ["일반", "Partnership"];

/* --------------------------------------------------------
   개발 문의 폼(/contact) 선택지 — 백엔드 app/inquiries.py 와 값이 일치해야 한다
   PARTNER_TYPE 을 고르면 공동개발 심사 항목(PARTNER)이 폼에 열린다.
   -------------------------------------------------------- */
export const PARTNER_TYPE = "공동개발(Partnership) 문의";

export const INQUIRY_TYPES = [
  PARTNER_TYPE,
  "웹사이트 제작",
  "개발지원 컨설팅",
  "일반 개발 의뢰",
  "회로 · PCB",
  "펌웨어",
  "서버 · 웹",
  "판매제품 · 자료실",
  "기술 자문",
  "교육",
  "기타",
];

export const PROJECT_STAGES = [
  "아이디어",
  "기획 · 사양 정리됨",
  "시제품 있음",
  "양산 준비",
];

export const BUDGET_RANGES = [
  "미정",
  "300만원 미만",
  "300~1,000만원",
  "1,000~3,000만원",
  "3,000~5,000만원",
  "5,000만원 이상",
];

/* 공동개발(Partnership) 문의 심사 항목 */
export const PARTNER = {
  bizTypes: ["개인", "개인사업자", "법인", "예비창업"],
  salesChannels: ["이미 고객 있음", "판로 있음", "계획만 있음", "없음"],
  govSupport: ["선정됨", "신청 예정", "해당 없음"],
  done: "공동개발 문의는 검토 후 1주 이내 연락드립니다. 모든 공동개발 문의가 Partnership으로 진행되지는 않습니다.",
};

/* 첨부 파일 제한 — 백엔드 inquiries.py 와 맞춰 둘 것 */
export const ATTACHMENT = {
  maxBytes: 20 * 1024 * 1024,
  maxLabel: "20MB",
  accept: ".pdf,.zip,.7z,.png,.jpg,.jpeg,.webp,.gif,.hwp,.hwpx,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv",
  hint: "PDF · 압축파일 · 이미지 · 문서, 최대 20MB",
};
